import { Component, Input } from '@angular/core';
import { OrganisationUI } from '@src/models';
import { ObjectId } from '@src/types/id';

import { ItemType } from '../model/item.model';

/** TODO: не используется */
@Component({
  selector: 'app-list-item-organisations',
  templateUrl: './list-item-organisations.component.html',
  styleUrls: ['../styles/list-item.component.scss', './list-item-organisations.component.scss'],
})
export class ListItemOrganisationsComponent {
  @Input() set item(data: ItemType | undefined) {
    this.data = data as OrganisationUI;
  }

  @Input() selectedId: ObjectId;
  @Input() loading?: boolean;

  data?: OrganisationUI;
}
